import React from 'react';

import Link from 'gatsby-link';

import map from 'lodash/map';

import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

import BaseLayout from '../../layout/base';
import Pagination from './components/Pagination';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Post from './components/Post';

import BlogLogo from './assets/blog.svg';

const styles = theme => ({
  root: {},
  content: {
    padding: '42.8px 112.1px 60.3px 114px',
    [theme.breakpoints.down('md')]: {
      paddingLeft: 24,
      paddingRight: 24,
    },
  },
  item: {
    marginBottom: 26.1,
    marginRight: 40,
    [theme.breakpoints.down('md')]: {
      marginRight: 24,
    },
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  sidebarRight: {
    height: '100%',
    display: 'flex',
    marginTop: 26.2,
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  logoContainer: {
    height: 280,
    backgroundImage: 'linear-gradient(156deg, #6a27e8, #2a149a)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  posts: {
    marginTop: 26.2,
  },
});

const BlogsTemplate = ({ classes, pageContext, pathContext }) => {
  const {
    group: posts,
    category: postsCategory,
    author: postsAuthor,
    tag: postsTag,
    ...sidebarContext
  } = pageContext;

  const headerProps = {
    postsCategory,
    postsAuthor,
    postsTag,
  };

  return (
    <BaseLayout>
      <Grid container spacing={24} className={classes.root}>
        <Grid item xs={12} className={classes.logoContainer}>
          <Link to="/blog">
            <img src={BlogLogo} alt="blog-logo" />
          </Link>
        </Grid>
        <Grid item xs={12}>
          <Grid container className={classes.content}>
            <Header {...headerProps} />
            <Grid item xs={12} sm={8} className={classes.posts}>
              <Grid container>
                {map(posts, ({ node: { id, ...postProps } }) => (
                  <Grid
                    item
                    xs={12}
                    key={`post-${id}`}
                    className={classes.item}
                  >
                    <Post {...postProps} />
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid item xs={4} className={classes.sidebarRight}>
              <Sidebar {...sidebarContext} />
            </Grid>
            <Grid item xs={12}>
              <Pagination {...pathContext} className={classes.pagination} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </BaseLayout>
  );
};

export default withStyles(styles)(BlogsTemplate);
